import * as AdType from 'common/constants/ad-type';
import DFPAd from 'common/components/ad/dfp';
import FreeWheelAd from 'common/components/ad/freewheel';
import { observer } from 'mobx-react';


function DisplayAd(props) {
    return (
        <div className={ props.className }>
            { props.adType === AdType.DFP &&
            <DFPAd
                { ...props.dfpProps }
                id={ props.adID }
                key={ `${ props.adID }_dfp_${props.adKey}` }
            /> }
            <FreeWheelAd
                { ...props.fwProps }
                key={ `${ props.adID }_fw_${props.adKey}_${props.adType}` }
                id={ props.adID }
                style={{ display: props.adType === AdType.FREEWHEEL ? null : 'none' }}
            />
        </div>
    );
}

DisplayAd.propTypes = {
    adID: React.PropTypes.string.isRequired,
    adKey: React.PropTypes.string,
    adType: React.PropTypes.string.isRequired,
    dfpProps: React.PropTypes.object.isRequired,
    fwProps: React.PropTypes.object.isRequired
};

DisplayAd.defaultProps = {
    adKey: ''
};


export default observer(DisplayAd);



/** WEBPACK FOOTER **
 ** ./src/show-page/components/display-ad/index.js
 **/